// components/invoices/InvoicesHeader.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Invoices.module.css';

const InvoicesHeader = () => {
  return (
    <div className={styles.pageHeader}>
      <h1 className={styles.pageTitle}>Invoices</h1>
      <Link 
        to="/invoices/new"
        className={`${styles.btn} ${styles.btnPrimary}`}
      >
        + Create New Invoice
      </Link>
    </div>
  );
};

export default InvoicesHeader;